import React from 'react';
import "../../styles/screen-reader/main.css";

const Main = () => {
    return (
        <div className="screen-reader-main">
            <div className="container pt-5">
                <h2 className="my-heading" style={{ paddingLeft: 10, color: "black" }}>
                    Screen Reader
                </h2>
                <p
                    className="text-left"
                    style={{ paddingLeft: 10, paddingRight: 35, color: "black" }}
                >
                    Screen Reader enables people with visual impairments access the website.
                    Following is a list of screen reader softwares in different plateforms that
                    are used popularly.
                </p>
                <div className='screen-reader-table-main'>
                    <table className="table table-bordered">
                        <thead>
                            <tr>
                                <th>Screen Reader</th>
                                <th>Website</th>
                                <th>Free / Commercial</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr className="odd">
                                <td>Non Visual Desktop Access (NVDA)</td>
                                <td>
                                    <a
                                        href="http://www.nvda-project.org/"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.nvda-project.org/
                                    </a>
                                </td>
                                <td>Free</td>
                            </tr>
                            <tr className="even">
                                <td>System Access To Go</td>
                                <td>
                                    <a
                                        href="http://www.satogo.com/"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.satogo.com/
                                    </a>
                                </td>
                                <td>Free</td>
                            </tr>
                            <tr className="odd">
                                <td>Hal</td>
                                <td>
                                    <a
                                        href="http://www.yourdolphin.co.uk/productdetail.asp?id=5"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.yourdolphin.co.uk/productdetail.asp?id=5
                                    </a>
                                </td>
                                <td>Commercial</td>
                            </tr>
                            <tr className="even">
                                <td>JAWS</td>
                                <td>
                                    <a
                                        href="http://www.freedomscientific.com/products/software/jaws/"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.freedomscientific.com/products/software/jaws/
                                    </a>
                                </td>
                                <td>Commercial</td>
                            </tr>
                            <tr className="odd">
                                <td>Supernova</td>
                                <td>
                                    <a
                                        href="http://www.yourdolphin.co.uk/productdetail.asp?id=1"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.yourdolphin.co.uk/productdetail.asp?id=1
                                    </a>
                                </td>
                                <td>Commercial</td>
                            </tr>
                            <tr className="even">
                                <td>Window-Eyes</td>
                                <td>
                                    <a
                                        href="http://www.gwmicro.com/Window-Eyes/"
                                        target="_blank"
                                        title="External website that opens in a new window"
                                        rel="noopener noreferrer"
                                    >
                                        http://www.gwmicro.com/Window-Eyes/
                                    </a>
                                </td>
                                <td>Commercial</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    )
}

export default Main;